module.exports = __webpack_public_path__ + "img/tasks.646de7ec.svg";